import { Entity, Field } from "typegraph";

@Entity({
	many: "article_saved_search_many",
	delete: "article_saved_search_one_delete"
})
export class FavoriteSearch {
	@Field()
	public id: string;

	@Field()
	public count: number;

	@Field()
	public name: string;

	@Field()
	public description?: string;

	@Field()
	public query: string;
}

@Entity({ delete: "article_saved_search_one_delete" })
export class FavoriteSearchDelete {
	@Field()
	public id: number;
}



// WEBPACK FOOTER //
// ./src/panels/favorites/entities/FavoriteSearch.ts